import { toUserId } from '@streamr/utils';
import { MaxUint256 } from 'ethers';
export var StreamPermission;
(function (StreamPermission) {
    StreamPermission["EDIT"] = "edit";
    StreamPermission["DELETE"] = "delete";
    StreamPermission["PUBLISH"] = "publish";
    StreamPermission["SUBSCRIBE"] = "subscribe";
    StreamPermission["GRANT"] = "grant";
})(StreamPermission || (StreamPermission = {}));
export const PUBLIC_PERMISSION_USER_ID = '0x0000000000000000000000000000000000000000';
export const isPublicPermissionQuery = (query) => {
    return query.public === true;
};
export const toInternalPermissionQuery = async (query, streamIdBuilder) => {
    const typedBaseQuery = {
        ...query,
        streamId: await streamIdBuilder.toStreamID(query.streamId)
    };
    return ('userId' in typedBaseQuery)
        ? { ...typedBaseQuery, userId: toUserId(typedBaseQuery.userId) }
        : typedBaseQuery;
};
export const isPublicPermissionAssignment = (assignment) => {
    return assignment.public === true;
};
export const toInternalPermissionAssignment = (assignment) => {
    return ('userId' in assignment)
        ? { ...assignment, userId: toUserId(assignment.userId) }
        : assignment;
};
export const streamPermissionToSolidityType = (permission) => {
    switch (permission) {
        case StreamPermission.EDIT:
            return 0n;
        case StreamPermission.DELETE:
            return 1n;
        case StreamPermission.PUBLISH:
            return 2n;
        case StreamPermission.SUBSCRIBE:
            return 3n;
        case StreamPermission.GRANT:
            return 4n;
        default:
            break;
    }
    return 0n;
};
export const convertChainPermissionsToStreamPermissions = (chainPermissions) => {
    const now = Math.round(Date.now() / 1000);
    const permissions = [];
    if (chainPermissions.canEdit) {
        permissions.push(StreamPermission.EDIT);
    }
    if (chainPermissions.canDelete) {
        permissions.push(StreamPermission.DELETE);
    }
    if (chainPermissions.publishExpiration > now) {
        permissions.push(StreamPermission.PUBLISH);
    }
    if (chainPermissions.subscribeExpiration > now) {
        permissions.push(StreamPermission.SUBSCRIBE);
    }
    if (chainPermissions.canGrant) {
        permissions.push(StreamPermission.GRANT);
    }
    return permissions;
};
export const convertStreamPermissionsToChainPermission = (permissions) => {
    return {
        canEdit: permissions.includes(StreamPermission.EDIT),
        canDelete: permissions.includes(StreamPermission.DELETE),
        publishExpiration: permissions.includes(StreamPermission.PUBLISH) ? MaxUint256 : 0n,
        subscribeExpiration: permissions.includes(StreamPermission.SUBSCRIBE) ? MaxUint256 : 0n,
        canGrant: permissions.includes(StreamPermission.GRANT)
    };
};
//# sourceMappingURL=permission.js.map